import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';

const ADDITIONAL_PAYMENT_SETTINGS_DOC = 'additionalPayments';

const converter = {
  toFirestore(
    settings: BonusOverrideSettings.AdditionalPaymentSettings,
  ): firebase.firestore.DocumentData {
    return { ...settings };
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<BonusOverrideSettings.AdditionalPaymentSettings>,
    options: firebase.firestore.SnapshotOptions,
  ): BonusOverrideSettings.AdditionalPaymentSettings {
    return {
      ...snapshot.data(options),
    };
  },
};

// Staff-managed recognition payment settings for a driver-bonus program, stored
// beside the override settings doc
// (driverBonus/{bonusProgramId}/overrideSettings/additionalPayments). Its own
// doc so the override setting modals' full writes never touch it.
const getBonusAdditionalPaymentSettingsRef = ({
  accountId,
  bonusProgramId,
  db,
}: {
  accountId: string;
  bonusProgramId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_COLLECTION)
    .doc(bonusProgramId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_OVERRIDE_SETTINGS_SUBCOLLECTION)
    .doc(ADDITIONAL_PAYMENT_SETTINGS_DOC)
    .withConverter(converter);
};

export default getBonusAdditionalPaymentSettingsRef;
